import TicketingV2MobileMultipleImageDisplay from "@/components/FormRateLayout/MultipleImageDisplay/TicketingV2MobileMultipleImageDisplay";
import ThemedDesktopMultipleImageDisplay from "@/features/FormV2/sharedComponents/ThemedItemBlock/ThemedMultipleImageDisplay/ThemedDesktopMultipleImageDisplay";
import { useMediaQuery } from "@/hooks/useMediaQuery";

export type MultipleImageDisplayProps = {
  purchasedNumber: number;
  photoUrls: string[];
  title: string;
};

export const ThemedResponsiveMultipleImageDisplay = (props: MultipleImageDisplayProps) => {
  const { isSmallScreen } = useMediaQuery();

  return isSmallScreen ? (
    <TicketingV2MobileMultipleImageDisplay {...props} /> // nothing themed in the mobile version
  ) : (
    <ThemedDesktopMultipleImageDisplay {...props} />
  );
};
